import AppButton from "@/components/AppButton/i18n";
import AppFooter from "@/components/AppFooter/i18n";
import AppTopBar from "@/components/AppTopBar/i18n";
import ContinueButton from "@/components/ContinueButton/i18n";
import ContinueFooterButton from "@/components/ContinueFooterButton/i18n";
import FooterButton from "@/components/FooterButton/i18n";
import HelpClaim from "@/components/HelpClaim/i18n";
import HelpDetails from "@/components/HelpDetails/i18n";
import InfoCard from "@/components/InfoCard/i18n";
import MediaDesktopHandoff from "@/components/MediaDesktopHandoff/i18n";
import NotFoundModel from "@/components/NotFoundModel/i18n";
import OwnershipConfirmationDialog from "@/components/OwnershipConfirmationDialog/i18n";
import PhaseCompleted from "@/components/PhaseCompleted/i18n";
import RenewalBikeWrongModal from "@/components/RenewalBikeWrongModal/i18n";
import TermsDialog from "@/components/TermsDialog/i18n";
import TermsText from "@/components/TermsText/i18n";
import type { Internationalization } from "../i18n";

export const components: Internationalization = {
  pt: {
    appButton: AppButton.pt,
    appFooter: AppFooter.pt,
    appTopBar: AppTopBar.pt,
    continueButton: ContinueButton.pt,
    continueFooterButton: ContinueFooterButton.pt,
    footerButton: FooterButton.pt,
    helpClaim: HelpClaim.pt,
    helpDetails: HelpDetails.pt,
    infoCard: InfoCard.pt,
    mediaDesktopHandoff: MediaDesktopHandoff.pt,
    notFoundModel: NotFoundModel.pt,
    ownershipConfirmationDialog: OwnershipConfirmationDialog.pt,
    phaseCompleted: PhaseCompleted.pt,
    renewalBikeWrongModal: RenewalBikeWrongModal.pt,
    termsDialog: TermsDialog.pt,
    termsText: TermsText.pt,
  },
  en: {
    appButton: AppButton.en,
    appFooter: AppFooter.en,
    appTopBar: AppTopBar.en,
    continueButton: ContinueButton.en,
    continueFooterButton: ContinueFooterButton.en,
    footerButton: FooterButton.en,
    helpClaim: HelpClaim.en,
    helpDetails: HelpDetails.en,
    infoCard: InfoCard.en,
    mediaDesktopHandoff: MediaDesktopHandoff.en,
    notFoundModel: NotFoundModel.en,
    ownershipConfirmationDialog: OwnershipConfirmationDialog.en,
    phaseCompleted: PhaseCompleted.en,
    renewalBikeWrongModal: RenewalBikeWrongModal.en,
    termsDialog: TermsDialog.en,
    termsText: TermsText.en,
  },
};
